import React, { useState } from "react";
import { Paper, Tabs, Tab } from '@material-ui/core';
import { TechSpecsNav } from '../../elements'
import { CrewSeat, Lavatories, PassengerCabin, Galley, Equipments, LOPA, AssetInfo } from '../components'
import useAssetInfo from '../hooks/useAssetInfo';
import { avationPlcInstance, titanAviInstance, mtInstance } from "../../../shared/components";
import CargoComp from "../components/CargoComp";
const Interior = ({params}) => {
    const [tabIndex, setTabIndex] = useState('crew-seat');
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    return(
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{height:`${window.innerHeight-162}px`}}>
                <TechSpecsNav />
                <div className="tech-specs-content">
                    <Paper elevation={0} className="console-paper" style={{margin:'0px 10px', marginBottom:'5px'}}>
                        <Tabs indicatorColor="primary" value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)}>
                            <Tab style={{minWidth:'130px'}} label="Crew Seat" value={'crew-seat'} />
                            <Tab label="Lavatories" value={'lavatories'} />
                            {(titanAviInstance||avationPlcInstance||mtInstance)?assetInfoData?.aircraft_operation!== 2?<Tab label="Passenger Cabin" value={'passenger-cabin'}/>:null
                            :<Tab label="Passenger Cabin" value={'passenger-cabin'}/>}
                            <Tab style={{minWidth:'110px'}} label="Galley" value={'galley'} />
                            <Tab label="Equipments" value={'equipments'} />
                            <Tab style={{minWidth:'100px'}} label="LOPA" value={'lopa'} />
                            <Tab label="Cargo COmpartment" value={'cargo'}/>
                        </Tabs>
                    </Paper>
                    <div>
                        {tabIndex === 'crew-seat' ? <CrewSeat  assetInfoData={assetInfoData}/>:null}
                        {tabIndex === 'lavatories' ? <Lavatories assetInfoData={assetInfoData} />:null}
                        {tabIndex === 'passenger-cabin' ? <PassengerCabin assetInfoData={assetInfoData} />:null}
                        {tabIndex === 'galley' ? <Galley assetInfoData={assetInfoData} />:null}
                        {tabIndex === 'equipments' ? <Equipments assetInfoData={assetInfoData}/>:null}
                        {tabIndex === 'lopa' ? <LOPA  assetInfoData={assetInfoData}/>:null}
                        {tabIndex ==='cargo' ? <CargoComp assetInfoData={assetInfoData}/>:null}
                    </div>
                </div>
            </Paper>
        </section>
    )
}
export default Interior;